/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaStep from 'DesignSystem/TysiaStep/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Steps/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaStep
  viewPath={`${viewPath}/TysiaStep`}
 complete={true}
 selected={true}
 step={1}
 text="Pay downpayment"
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaStep
  viewPath={`${viewPath}/TysiaStep`}
 selected={true}
 step={2}
 text="Setup payment in installments"
/>
</div>
{children}
</React.Fragment>)
}